<template>
  <div id="brassicadb">
    <div id="home">
      <div class="header1">
        <!-- <div style="height: 25px; background-color: #7BAE82"></div> -->
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="#7BAE82" text-color="#FFFFFF" active-text-color="#FF9999">
          <el-menu-item index="1"><img src="./assets/img/brad_logo2.png" style="height: 80px;width: 140px;margin-top: 0px"></el-menu-item>
          <el-menu-item index="2">Home</el-menu-item>
          <el-submenu index="3">
            <template slot="title">Browse</template>
            <el-menu-item index="3-1">Species info</el-menu-item>
            <el-menu-item index="3-2">Anthocyanin genes</el-menu-item>
            <el-menu-item index="3-3">Auxin genes</el-menu-item>
            <el-menu-item index="3-4">Flower genes</el-menu-item>
            <el-menu-item index="3-5">Glucosinolate genes</el-menu-item>
            <el-menu-item index="3-6">Resistance genes</el-menu-item>
            <el-menu-item index="3-7">Transcription factor</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">Search</template>
            <el-menu-item index="4-1">Annotations</el-menu-item>
            <el-menu-item index="4-2">Syntenic gene @ Subgenome</el-menu-item>
            <el-menu-item index="4-3">Flanking region</el-menu-item>
            <el-menu-item index="4-4">Nonsyntenic Orth</el-menu-item>
            <el-menu-item index="4-5">Synteny @ Genome</el-menu-item>
            <el-menu-item index="4-6">Gene sequence</el-menu-item>
            <el-menu-item index="4-7">Transcriptome</el-menu-item>
            <el-menu-item index="4-8">Polymorph</el-menu-item>
            <el-menu-item index="4-9">BrapaLeafeFP</el-menu-item>
            <el-menu-item index="4-10">BrapaLeafCelleFP</el-menu-item>
            <el-menu-item index="4-11">ProteinStructure</el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">Tools</template>
            <el-menu-item index="5-1">BLAST</el-menu-item>
            <el-menu-item index="5-2">JBrowse</el-menu-item>
            <el-menu-item index="5-3">Multiple sequence alignment</el-menu-item>
            <el-menu-item index="5-4">Gene Phylogeny</el-menu-item>
            <el-menu-item index="5-5">Genomic sequence retrieval</el-menu-item>
            <el-menu-item index="5-6">MicroSynteny</el-menu-item>
            <el-menu-item index="5-7">Primer Design</el-menu-item>
          </el-submenu>
          <el-menu-item index="6">Download</el-menu-item>
          <el-submenu index="7">
            <template slot="title">Links</template>
            <el-menu-item index="7-1">TAIR</el-menu-item>
            <el-menu-item index="7-2">Brassica info</el-menu-item>
            <el-menu-item index="7-3">Brassica@JCVI</el-menu-item>
            <el-menu-item index="7-4">Brassica Genome</el-menu-item>
            <el-menu-item index="7-5">GenoScope</el-menu-item>
            <el-menu-item index="7-6">BnIR/BnPIR</el-menu-item>
            <el-menu-item index="7-7">BnTIR</el-menu-item>
            <el-menu-item index="7-8">BnVIR</el-menu-item>
            <el-menu-item index="7-9">BrassicaEDB</el-menu-item>
            <el-menu-item index="7-10">Marker</el-menu-item>
          </el-submenu>
          <el-menu-item index="8">Userguide</el-menu-item>
        </el-menu>
        <!-- <div class="toubu">
          <ul class="daohang">
            <li style="padding-right: 0px"><img src="./assets/img/brad_logo2.png" style="height: 80px;width: 140px;margin-top: -20px"></li>
            <li><div class="daohang_button"><button @click="showValue('Home')" class="router">Home</button></div></li>

            <li>
              <div class="dropdown">
                <button class="dropbtn"><span style="font: bold 18px georgia;">Browse</span></button>
                <div class="dropdown-content">
                  <button class="aaa" @click="showValue('Species info')">Species info</button>
                  <button class="aaa" @click="showValue('Anthocyanin genes')">Anthocyanin genes</button>
                  <button class="aaa" @click="showValue('Auxin genes')">Auxin genes</button>
                  <button class="aaa" @click="showValue('Flower genes')">Flower genes</button>
                  <button class="aaa" @click="showValue('Glucosinolate genes')">Glucosinolate genes</button>
                  <button class="aaa" @click="showValue('Resistance genes')">Resistance genes</button>
                  <button class="aaa" @click="showValue('Transcription factor')">Transcription factor</button>
                </div>
              </div>
            </li>
            <li>
              <div class="dropdown">
                <button class="dropbtn"><span style="font: bold 18px georgia;">Search</span></button>
                <div class="dropdown-content">
                  <button class="aaa" @click="showValue('Annotations')">Annotations</button>
                  <button class="aaa" @click="showValue('Syntenic gene @ Subgenome')">Syntenic gene @ Subgenome</button>
                  <button class="aaa" @click="showValue('Flanking region')">Flanking region</button>
                  <button class="aaa" @click="showValue('Nonsyntenic Orth')">Nonsyntenic Orth</button>
                  <button class="aaa" @click="showValue('Synteny @ Genome')">Synteny @ Genome</button>
                  <button class="aaa" @click="showValue('Gene sequence')">Gene sequence</button>
                  <button class="aaa" @click="showValue('Transcriptome')">Transcriptome</button>
                  <button class="aaa" @click="showValue('Polymorph')">Polymorph</button>
                  <button class="aaa" @click="showValue('BrapaLeafeFP')">BrapaLeafeFP</button>
                </div>
              </div>
            </li>

            <li>
              <div class="dropdown">
                <button class="dropbtn"><span style="font: bold 18px georgia;">Tools</span></button>
                <div class="dropdown-content">
                  <button class="aaa" @click="showValue('BLAST')">BLAST</button>
                  <button class="aaa" @click="showValue('JBrowse')">JBrowse</button>
                  <button class="aaa" @click="showValue('Multiple sequence alignment')">Multiple sequence alignment</button>
                  <button class="aaa" @click="showValue('Gene Phylogeny')">Gene Phylogeny</button>
                  <button class="aaa" @click="showValue('Genomic sequence retrieval')">Genomic sequence retrieval</button>
                  <button class="aaa" @click="showValue('MicroSynteny')">MicroSynteny</button>
                  <button class="aaa" @click="showValue('Primer Design')">Primer Design</button>
                </div>
              </div>
            </li>

            <li><div class="daohang_button"><button class="router" @click="showValue('Download')">Download</button></div></li>
            <li><div style="margin-left: 20px" class="daohang_button"><button class="router" @click="showValue($event)">Marker</button></div></li>

            <li>
              <div class="dropdown">
                <button class="dropbtn"><span style="font: bold 18px georgia;">Links</span></button>
                <div class="dropdown-content">
                  <button class="aaa" @click="showValue('TAIR')">TAIR</button>
                  <button class="aaa" @click="showValue('Brassica info')">Brassica info</button>
                  <button class="aaa" @click="showValue('Brassica@JCVI')">Brassica@JCVI</button>
                  <button class="aaa" @click="showValue('Brassica Genome')">Brassica Genome</button>
                  <button class="aaa" @click="showValue('GenoScope')">GenoScope</button>
                  <button class="aaa" @click="showValue('BnPIR')">BnPIR</button>
                  <button class="aaa" @click="showValue('BnTIR')">BnTIR</button>
                  <button class="aaa" @click="showValue('BnVIR')">BnVIR</button>
                  <button class="aaa" @click="showValue('BrassicaEDB')">BrassicaEDB</button>
                  <button class="aaa" @click="showValue('Marker')">Marker</button>
                </div>
              </div>
            </li>

            <li><div style="margin-left: -30px" class="daohang_button"><button class="router" @click="showValue($event)">Userguide</button></div></li>

          </ul>
          
        </div> -->
      </div>
      <div>
        <Header/>
      </div>

      <div>
        <!-- <router-view/> -->
        <router-view>

        </router-view>
      </div>
      <Foot/>
    </div>
  </div>
</template>

<script>
  import Foot from "./components/Foot";
  import Header from "./components/Header";
  export default {
    data() {
      return {
        currentPage: 'home',
        activeIndex: '1',
        activeIndex2: '1',
      }
    },
    components:{
      // Toubu,
      Foot,
      Header
      // Synorths,
    },
    mounted() {

    },
    methods:{
      handleSelect(key, keyPath) {                         // eslint-disable-line no-unused-vars
        // console.log(key, keyPath);
        // console.log(key)
        // console.log(keyPath[1])
        if (keyPath[0] == '1') {
          this.$router.push({path: '/'});
        }
        else if (keyPath[0] == '2') {
          this.$router.push({path: '/'});
        }
        else if (keyPath[0] == '3') {
          if (keyPath[1] == '3-1') {
            this.$router.push({path: '/SpeciesInfo/'});
          }
          else if (keyPath[1] == '3-2') {
            this.$router.push({path: '/AnthocyaninGene/'});
          }
          else if (keyPath[1] == '3-3') {
            this.$router.push({path: '/AuxinGene/'});
          }
          else if (keyPath[1] == '3-4') {
            this.$router.push({path: '/FlowerGene/'});
          }
          else if (keyPath[1] == '3-5') {
            this.$router.push({path: '/GlucosinolateGene/'});
          }
          else if (keyPath[1] == '3-6') {
            this.$router.push({path: '/ResistanceGene/'});
          }
          else if (keyPath[1] == '3-7') {
            this.$router.push({path: '/TranscriptionFactorGene/'});
          }
        }
        else if (keyPath[0] == '4') {
          if (keyPath[1] == '4-1') {
            this.$router.push({path: '/Annotations/'});
          }
          else if (keyPath[1] == '4-2') {
            this.$router.push({path: '/syntenic-gene/'});
          }
          else if (keyPath[1] == '4-3') {
            this.$router.push({path: '/FlankingRegion/'});
          }
          else if (keyPath[1] == '4-4') {
            this.$router.push({path: '/NonSyntenicOrthologs/'});
          }
          else if (keyPath[1] == '4-5') {
            this.$router.push({path: '/SyntenicFigure/'});
          }
          else if (keyPath[1] == '4-6') {
            this.$router.push({path: '/GeneSequence/'});
          }
          else if (keyPath[1] == '4-7') {
            this.$router.push({path: '/Transcriptome/'});
          }
          else if (keyPath[1] == '4-8') {
            this.$router.push({path: '/Polymorph/'});
          }
          else if (keyPath[1] == '4-9') {
            this.$router.push({path: '/BrapaLeafeFP/'});
          }
          else if (keyPath[1] == '4-10') {
            this.$router.push({path: '/BrapaLeafCelleFP/'});
          }
          else if (keyPath[1] == '4-11') {
            this.$router.push({path: '/ProteinStructure/'})
          }
        }
        else if (keyPath[0] == '5') {
          if (keyPath[1] == '5-1') {
            this.$router.push({path: '/BLAST/'});
          }
          else if (keyPath[1] == '5-2') {
            this.$router.push({path: '/JBrowse/'});
          }
          else if (keyPath[1] == '5-3') {
            this.$router.push({path: '/MSA/'});
          }
          else if (keyPath[1] == '5-4') {
            this.$router.push({path: '/phylogeneticTree/'});
          }
          else if (keyPath[1] == '5-5') {
            this.$router.push({path: '/GenomicSequenceRetrieval/'});
          }
          else if (keyPath[1] == '5-6') {
            this.$router.push({path: '/RegionMicroSynteny/'});
          }
          else if (keyPath[1] == '5-7') {
            this.$router.push({path: '/PrimerDesign/'});
          }
        }
        else if (keyPath[0] == '6') {
          this.$router.push({path: '/Download/'});
        }
        else if (keyPath[0] == '7') {
          if (keyPath[1] == '7-1') {
            window.open('https://www.arabidopsis.org/index.jsp', '_blank');
          }
          else if (keyPath[1] == '7-2') {
            window.open('http://www.brassica.info/', '_blank');
          }
          else if (keyPath[1] == '7-3') {
            window.open('http://blast.jcvi.org/er-blast/index.cgi?project=bog1', '_blank');
          }
          else if (keyPath[1] == '7-4') {
            window.open('http://www.brassicagenome.net/', '_blank');
          }
          else if (keyPath[1] == '7-5') {
            window.open('https://www.genoscope.cns.fr/brassicanapus/', '_blank');
          }
          else if (keyPath[1] == '7-6') {
            window.open('http://yanglab.hzau.edu.cn/BnIR', '_blank');
          }
          else if (keyPath[1] == '7-7') {
            window.open('http://yanglab.hzau.edu.cn/BnTIR', '_blank');
          }
          else if (keyPath[1] == '7-8') {
            window.open('http://yanglab.hzau.edu.cn/BnVIR', '_blank');
          }
          else if (keyPath[1] == '7-9') {
            window.open('https://brassica.biodb.org/', '_blank');
          }
          else if (keyPath[1] == '7-10') {
            this.$router.push({path: '/Marker/'})
          }
        }
        else if (keyPath[0] == '8') {
          this.$router.push({path: '/Userguide/'});
        }
      },
      // showValue(event){
      //   var e = event;
      //   // console.log("OKOKOOK2")
      //   // alert(e.innerHTML);
      //   if (e == 'Home') {
      //     this.$router.push({path: '/'});
      //   }
      //   else if (e == 'Syntenic gene @ Subgenome') {
      //     this.$router.push({path: '/syntenic-gene/'});
      //   }
      //   else if (e == 'Annotations') {
      //     this.$router.push({path: '/Annotations/'});
      //   }
      //   else if (e == 'Flanking region') {
      //     this.$router.push({path: '/FlankingRegion/'})
      //   }
      //   else if (e == 'Nonsyntenic Orth') {
      //     this.$router.push({path: '/NonSyntenicOrthologs/'})
      //   }
      //   else if (e == 'JBrowse') {
      //     this.$router.push({path: '/JBrowse/'});
      //   }
      //   else if (e == 'BLAST') {
      //     this.$router.push({path: '/BLAST/'});
      //   }
      //   else if (e == 'Gene sequence') {
      //     this.$router.push({path: '/GeneSequence/'})
      //   }
      //   else if (e == 'Species info') {
      //     this.$router.push({path: '/SpeciesInfo/'})
      //   }
      //   else if (e == 'Download') {
      //     this.$router.push({path: '/Download/'})
      //   }
      //   else if (e == 'Synteny @ Genome') {
      //     this.$router.push({path: '/SyntenicFigure/'})
      //   }
      //   else if (e == 'Anthocyanin genes') {
      //     this.$router.push({path: '/AnthocyaninGene/'})
      //   }
      //   else if (e == 'Auxin genes') {
      //     this.$router.push({path: '/AuxinGene/'})
      //   }
      //   else if (e == 'Flower genes') {
      //     this.$router.push({path: '/FlowerGene/'})
      //   }
      //   else if (e == 'Glucosinolate genes') {
      //     this.$router.push({path: '/GlucosinolateGene/'})
      //   }
      //   else if (e == 'Resistance genes') {
      //     this.$router.push({path: '/ResistanceGene/'})
      //   }
      //   else if (e == 'Genomic sequence retrieval') {
      //     this.$router.push({path: '/GenomicSequenceRetrieval/'})
      //   }
      //   else if (e == 'MicroSynteny') {
      //     this.$router.push({path: '/RegionMicroSynteny/'})
      //   }
      //   else if (e == 'Primer Design') {
      //     this.$router.push({path: '/PrimerDesign/'})
      //   }
      //   else if (e == 'Transcriptome') {
      //     this.$router.push({path: '/Transcriptome/'})
      //   }
      //   else if (e == 'Polymorph') {
      //     this.$router.push({path: '/Polymorph/'})
      //   }
      //   else if (e == 'BrapaLeafeFP') {
      //     this.$router.push({path: '/BrapaLeafeFP/'})
      //   }
      //   else if (e == 'Multiple sequence alignment') {
      //     this.$router.push({path: '/MSA/'})
      //   }
      //   else if (e == 'Gene Phylogeny') {
      //     this.$router.push({path: '/phylogeneticTree/'})
      //   }
      //   else if (e == 'Transcription factor') {
      //     this.$router.push({path: '/TranscriptionFactorGene/'})
      //   }
      //   else if (e == 'Marker') {
      //     this.$router.push({path: '/Marker/'})
      //   }
      //   else if (e == 'Userguide') {
      //     this.$router.push({path: '/Userguide/'})
      //   }
      //   else if (e == 'TAIR') {
      //     window.open('https://www.arabidopsis.org/index.jsp', '_blank')
      //   }
      //   else if (e == 'Brassica info') {
      //     window.open('http://www.brassica.info/', '_blank')
      //   }
      //   else if (e == 'GenoScope') {
      //     window.open('https://www.genoscope.cns.fr/brassicanapus/', '_blank')
      //   }
      //   else if (e == 'BrassicaEDB') {
      //     window.open('https://brassica.biodb.org/', '_blank')
      //   }
      //   else if (e == 'BnPIR') {
      //     window.open('http://cbi.hzau.edu.cn/bnapus/', '_blank')
      //   }
      //   else if (e == 'BnTIR') {
      //     window.open('http://yanglab.hzau.edu.cn/BnTIR', '_blank')
      //   }
      //   else if (e == 'BnVIR') {
      //     window.open('http://yanglab.hzau.edu.cn/BnVIR', '_blank')
      //   }
      //   else if (e == 'Brassica@JCVI') {
      //     window.open('http://blast.jcvi.org/er-blast/index.cgi?project=bog1', '_blank')
      //   }
      //   else if (e == 'Brassica Genome') {
      //     window.open('http://www.brassicagenome.net/', '_blank')
      //   }
      //   // console.log(e.firstChild.data)
      // }
    },
  }

var cnzz_s_tag = document.createElement('script');
cnzz_s_tag.type = 'text/javascript';
cnzz_s_tag.async = true;
cnzz_s_tag.charset = 'utf-8';
cnzz_s_tag.src = 'http://w.cnzz.com/c.php?id= 1279595126 &async=1';
var root_s = document.getElementsByTagName('script')[0];
root_s.parentNode.insertBefore(cnzz_s_tag, root_s);

</script>

<style>

  /* html, body {
    height: 100%;
    width: 100%;
    border: hidden;
    overflow: auto;
  } */

  .header1 .el-menu-demo {
    height: 80px;
    /* border: 1px solid #000; */
  }

  .header1 .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .header1 .el-menu--horizontal > .el-menu-item {
    height: 80px;
    line-height: 80px;
    font-size: 20px;
    font-weight: bold;
  }

  .header1 .el-menu--horizontal > .el-submenu > .el-menu-item {
    font-size: 20px;
    font-weight: bold;
  }

  .header1 .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 80px;
    line-height: 80px;
    font-size: 18px;
    font-weight: bold;
  }

  .header1 .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: none;
    height: 80px;
  }

  .header1 .el-menu--horizontal .el-submenu {
    margin-left: 40px
  }

</style>
